/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */
import React from "react";
import classnames from "classnames";
import { TickOutlined as TickIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/TickOutlined";

// Styles
import styles from "./tick-list.module.scss";

function TickList({ items = [], squeezed = false }) {
  return (
    <ul className={classnames(styles["tick-list"], squeezed ? styles["tick-list--squeezed"] : null)}>
      {items.map((item, i) => (
        <li key={i}>
          <TickIcon className={styles["tick-list__icon"]} />
          <div dangerouslySetInnerHTML={{ __html: item }} />
        </li>
      ))}
    </ul>
  );
}

export default TickList;
